import request from '../request';
// 获取所有
export const allApply = (params) => {
  return request({
    url: '/v3/resume_hr_permissions',
    method: 'get',
    params,
  })
}
// 操作
export const applyOperate = (permission_id, data) => {
  return request({
    url: `/v3/resume_hr_permissions/${permission_id}`,
    method: 'post',
    data
  })
}

// 发送附件简历到hr
export const sendCvToHr = (permission_id, cv_token, data) => {
  return request({
    url: `/v3/resume_hr_permissions/${permission_id}/cv_attach/${cv_token}`,
    method: 'post',
    data
  })
}